import React from 'react';
import Flexbox from 'flexbox-react';
import PropTypes from 'prop-types';
import ProcessField from 'components/core/fields/ProcessField';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import RIESecondsInput from 'components/core/editable/RIESecondsInput';
import ProcessEditor from 'utils/ProcessEditor';

export default class InputOffsetsField extends ProcessField {
    static propTypes = Object.assign({
        inputDatasetName: PropTypes.string,
    }, ProcessField.propTypes);

    getInputDataset = () => {
        return this.props.process.variable_retrieval.input_datasets[this.props.inputDatasetName];
    };

    getStartOffset = () => {
        // get it from the dataset
        return this.getInputDataset().offsets[0];
    };

    getStartOffsetFieldPath = () => {
        return ['variable_retrieval', 'input_datasets', this.props.inputDatasetName, 'offsets', 0];
    };

    getEndOffset = () => {
        // get it from the dataset
        return this.getInputDataset().offsets[1];
    };

    getEndOffsetFieldPath = () => {
        return ['variable_retrieval', 'input_datasets', this.props.inputDatasetName, 'offsets', 1];
    };

    onStartOffsetChange = (fieldPath, value) => {
        const editor = new ProcessEditor(this.props.process);
        editor.updateField(fieldPath, value);
        editor.commit();
    };

    onEndOffsetChange = (fieldPath, value) => {
        const editor = new ProcessEditor(this.props.process);
        editor.updateField(fieldPath, value);
        editor.commit();
    };

    render() {
        return (
            <Flexbox className={this.props.className} flexDirection="row" margin="0 10px" alignItems="center">
                <div className="form-label">Offsets:</div>
                <Flexbox flexDirection="row" className="offsets-box" alignItems="center" width="100%">
                    {/* Start */}
                    <Flexbox className="offset" flexDirection="row" alignItems="flex-start">
                        <InfoBoxLabel className="noshrink" label="Start"
                                      message={'Number of extra seconds before the START of the processing interval to retrieve'}
                        />
                        <RIESecondsInput
                            value={this.getStartOffset()}
                            change={this.onStartOffsetChange}
                            fieldPath={this.getStartOffsetFieldPath()}
                            isDisabled={!this.props.hasWritePermissions}
                            isFullWidth={false}
                            processId={this.props.process.name}
                            processErrors={this.props.processErrors}
                        />
                    </Flexbox>

                    {/* End */}
                    <Flexbox className="offset" flexDirection="row" alignItems="flex-start">
                        <InfoBoxLabel className="noshrink" label="End"
                                      message={'Number of extra seconds after the END of the processing interval to retrieve'}
                        />
                        <RIESecondsInput
                            value={this.getEndOffset()}
                            change={this.onEndOffsetChange}
                            fieldPath={this.getEndOffsetFieldPath()}
                            isDisabled={!this.props.hasWritePermissions}
                            isFullWidth={false}
                            processId={this.props.process.name}
                            processErrors={this.props.processErrors}
                        />
                    </Flexbox>
                </Flexbox>
            </Flexbox>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/core/fields/InputOffsetsField.js